import { z } from "zod";
import { FieldBaseSchema, defineControl } from "./field.js";
// A check box has nowhere to show a placeholder: its label sits beside the box.
export const checkbox = defineControl({
    key: "checkbox",
    label: "Check box field",
    schema: FieldBaseSchema.extend({ control: z.literal("checkbox") }),
    answer: z.boolean(),
    isClearable: false,
    empty: { required: false },
});
